import { EMPTY_PLACEHOLDER } from "@/utils/constants"
import { isNullOrUndefined } from "@/utils/ts-utils"

export const getDisplayedName = (
  firstName: string | undefined | null,
  lastName: string | undefined | null
): string => {
  if (isNullOrUndefined(firstName)) {
    return isNullOrUndefined(lastName) ? EMPTY_PLACEHOLDER : lastName
  }
  if (isNullOrUndefined(lastName)) {
    return firstName
  }

  return `${firstName} ${lastName}`
}
